import React, { useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import { usePerfil } from '../context/PerfilContext';
import { NOVEDADES } from '../config/novedades';
import { esApp } from '../utils/plataforma';

interface Props {
  modulo: string;
  /** Qué hace el botón principal de cada novedad, por id. Sin acción, no sale el botón. */
  acciones?: Record<string, () => void>;
}

/** Avisos de novedades pendientes de ver para el módulo. Ver src/config/novedades.ts. */
export const Novedades: React.FC<Props> = ({ modulo, acciones = {} }) => {
  const { perfil, tieneModulo, marcarNovedadVista } = usePerfil();
  // Se ocultan al momento, sin esperar a que Firestore devuelva el perfil
  const [cerradas, setCerradas] = useState<Set<string>>(new Set());

  if (!perfil || !tieneModulo(modulo)) return null;

  const pendientes = NOVEDADES.filter(n =>
    n.modulo === modulo
    && (!n.soloApp || esApp)
    && !perfil.novedadesVistas?.[n.id]
    && !cerradas.has(n.id)
    // Solo a quien ya estaba: medianoche local del día de publicación
    && perfil.createdAt < new Date(`${n.publicada}T00:00:00`),
  );
  if (pendientes.length === 0) return null;

  const cerrar = (id: string) => {
    setCerradas(prev => new Set(prev).add(id));
    marcarNovedadVista(id).catch(e => console.error('No se pudo anotar la novedad como vista', e));
  };

  return (
    <div className="space-y-2 mb-6">
      {pendientes.map(n => {
        const accion = acciones[n.id];
        return (
          <div key={n.id} role="status"
            className="flex items-start gap-3 bg-blue-50 dark:bg-blue-900/25 border border-blue-200
                       dark:border-blue-800 rounded-xl px-4 py-3">
            <Sparkles className="w-5 h-5 text-blue-600 dark:text-blue-400 shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-blue-900 dark:text-blue-200">{n.titulo}</p>
              <p className="text-sm text-blue-800 dark:text-blue-300 mt-0.5">{n.texto}</p>
              <div className="flex flex-wrap gap-2 mt-2">
                {n.accion && accion && (
                  <button onClick={() => { cerrar(n.id); accion(); }}
                    className="px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold transition">
                    {n.accion}
                  </button>
                )}
                <button onClick={() => cerrar(n.id)}
                  className="px-3 py-1.5 rounded-lg border border-blue-300 dark:border-blue-700 text-blue-700
                             dark:text-blue-300 text-xs font-semibold hover:bg-blue-100 dark:hover:bg-blue-900/40 transition">
                  Entendido
                </button>
              </div>
            </div>
            <button onClick={() => cerrar(n.id)} aria-label="Cerrar aviso"
              className="p-1 rounded-lg text-blue-400 hover:text-blue-700 dark:hover:text-blue-200 transition shrink-0">
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
};
